import { render, staticRenderFns } from "./AddGame.vue?vue&type=template&id=59a67f43"
import script from "./AddGame.vue?vue&type=script&lang=js"
export * from "./AddGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports